export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40700577f194a81231fe4c0e074b8b47844ee42f94&name=revalidateCommunity!'